var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpecializedTuas(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6310_103244)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6310_103244",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 38,
    height: 38
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.8147e-06H38V38H0V3.8147e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6310_103244)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.9481 21.3796H13.0492C12.392 21.3796 11.8594 20.8469 11.8594 20.1898V17.8099C11.8594 17.1528 12.392 16.6201 13.0492 16.6201H24.9481C25.6053 16.6201 26.138 17.1528 26.138 17.8099V20.1898C26.138 20.8469 25.6053 21.3796 24.9481 21.3796Z",
    stroke: "white",
    strokeWidth: 1.11328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9481 14.2402H13.0492C12.392 14.2402 11.8594 13.7075 11.8594 13.0504V10.6705C11.8594 10.0134 12.392 9.48066 13.0492 9.48066H24.9481C25.6053 9.48066 26.138 10.0134 26.138 10.6705V13.0504C26.138 13.7075 25.6053 14.2402 24.9481 14.2402Z",
    stroke: "white",
    strokeWidth: 1.11328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3532 23.7597H24.9481C25.6054 23.7597 26.138 24.2925 26.138 24.9496V27.3294C26.138 27.9865 25.6054 28.5193 24.9481 28.5193H13.0492C12.392 28.5193 11.8594 27.9865 11.8594 27.3294V24.9496C11.8594 24.2925 12.392 23.7597 13.0492 23.7597H21.9735",
    stroke: "white",
    strokeWidth: 1.11328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2344 11.8606H14.8293",
    stroke: "white",
    strokeWidth: 1.11328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2344 26.1394H14.8293",
    stroke: "white",
    strokeWidth: 1.11328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2344 19H14.8293",
    stroke: "white",
    strokeWidth: 1.11328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7631 19H17.2188",
    stroke: "white",
    strokeWidth: 1.11328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7631 11.8606H17.2188",
    stroke: "white",
    strokeWidth: 1.11328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7631 26.1394H17.2188",
    stroke: "white",
    strokeWidth: 1.11328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 21.3798V23.7595",
    stroke: "white",
    strokeWidth: 1.11328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 28.5194V31.4941",
    stroke: "white",
    strokeWidth: 1.11328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 6.50595V9.48071",
    stroke: "white",
    strokeWidth: 1.11328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 16.6204V14.2406",
    stroke: "white",
    strokeWidth: 1.11328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9729 3.53134C21.9729 5.17425 20.641 6.5061 18.9981 6.5061C17.3553 6.5061 16.0234 5.17425 16.0234 3.53134C16.0234 1.88844 17.3553 0.55658 18.9981 0.55658C20.641 0.55658 21.9729 1.88844 21.9729 3.53134Z",
    stroke: "white",
    strokeWidth: 1.11328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9729 34.4686C21.9729 36.1115 20.641 37.4434 18.9981 37.4434C17.3553 37.4434 16.0234 36.1115 16.0234 34.4686C16.0234 32.8257 17.3553 31.4938 18.9981 31.4938C20.641 31.4938 21.9729 32.8257 21.9729 34.4686Z",
    stroke: "white",
    strokeWidth: 1.11328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4669 21.9749C32.824 21.9749 31.4922 20.643 31.4922 19.0001C31.4922 17.3573 32.824 16.0254 34.4669 16.0254C36.1099 16.0254 37.4417 17.3573 37.4417 19.0001C37.4417 20.643 36.1099 21.9749 34.4669 21.9749Z",
    stroke: "white",
    strokeWidth: 1.11328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.52945 21.9749C1.88654 21.9749 0.554688 20.643 0.554688 19.0001C0.554688 17.3573 1.88654 16.0254 3.52945 16.0254C5.17236 16.0254 6.50421 17.3573 6.50421 19.0001C6.50421 20.643 5.17236 21.9749 3.52945 21.9749Z",
    stroke: "white",
    strokeWidth: 1.11328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.50781 19H11.8624",
    stroke: "white",
    strokeWidth: 1.11328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1406 19H31.4952",
    stroke: "white",
    strokeWidth: 1.11328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8047 28.9946C31.9798 27.6081 32.9149 26.0118 33.5462 24.2696",
    stroke: "white",
    strokeWidth: 1.11328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2656 33.5464C25.9793 32.9254 27.5519 32.0104 28.9226 30.8622",
    stroke: "white",
    strokeWidth: 1.11328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.01562 30.8157C10.3992 31.9857 11.9911 32.9171 13.7279 33.5464",
    stroke: "white",
    strokeWidth: 1.11328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.45312 24.2697C5.06758 25.9654 5.97001 27.523 7.1014 28.8835",
    stroke: "white",
    strokeWidth: 1.11328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.2557 8.93362C6.05195 10.3367 5.09527 11.958 4.45312 13.7302",
    stroke: "white",
    strokeWidth: 1.11328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7262 4.45353C11.9541 5.09567 10.3327 6.05235 8.92969 7.2561",
    stroke: "white",
    strokeWidth: 1.11328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9652 7.17358C27.5846 6.00857 25.9971 5.08099 24.2656 4.45354",
    stroke: "white",
    strokeWidth: 1.11328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5463 13.7302C32.915 11.988 31.9798 10.3916 30.8047 9.00501",
    stroke: "white",
    strokeWidth: 1.11328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.52945 21.9749C1.88654 21.9749 0.554688 20.643 0.554688 19.0001C0.554688 17.3573 1.88654 16.0254 3.52945 16.0254C5.17236 16.0254 6.50421 17.3573 6.50421 19.0001C6.50421 20.643 5.17236 21.9749 3.52945 21.9749Z",
    stroke: "white",
    strokeWidth: 1.11328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.22351 8.90344C6.75883 8.43876 6.75883 7.68536 7.22351 7.22068C7.6882 6.756 8.44159 6.756 8.90627 7.22068C9.37096 7.68536 9.37096 8.43876 8.90627 8.90344C8.44159 9.36812 7.6882 9.36812 7.22351 8.90344Z",
    stroke: "white",
    strokeWidth: 1.11328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0907 30.7794C28.626 30.3147 28.626 29.5613 29.0907 29.0967C29.5554 28.632 30.3088 28.632 30.7735 29.0967C31.2381 29.5613 31.2381 30.3147 30.7735 30.7794C30.3088 31.2441 29.5554 31.2441 29.0907 30.7794Z",
    stroke: "white",
    strokeWidth: 1.11328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0907 7.22068C29.5554 6.756 30.3088 6.756 30.7735 7.22068C31.2381 7.68536 31.2381 8.43876 30.7735 8.90344C30.3088 9.36812 29.5554 9.36812 29.0907 8.90344C28.626 8.43876 28.626 7.68536 29.0907 7.22068Z",
    stroke: "white",
    strokeWidth: 1.11328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.22351 29.0967C7.6882 28.632 8.44159 28.632 8.90627 29.0967C9.37096 29.5613 9.37096 30.3147 8.90627 30.7794C8.44159 31.2441 7.6882 31.2441 7.22351 30.7794C6.75883 30.3147 6.75883 29.5613 7.22351 29.0967Z",
    stroke: "white",
    strokeWidth: 1.11328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6310_103244"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpecializedTuas);
export default __webpack_public_path__ + "static/media/specialized_TUAS.c2d7da66879ea56f7d8c392e71eee4db.svg";
export { ForwardRef as ReactComponent };